<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="700px"
      :fullscreen="isMobileBreakpoint"
      :persistent="isMobileBreakpoint"
    >
      <v-card class="py-3">
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title
            class="renameVideoModalTitle ml-3 d-flex flex-column"
          >
            {{ $t('message.pages.pandaAssist.embedModal.title') }}
            <span class="body-regular-smaller"
              >{{ $t('message.pages.pandaAssist.embedModal.description') }}
              <span class="body-bold-smaller"
                ><a type="secondary" size="xsmall" @click="openHelp"
                  >{{ $t('message.pages.AssistentIntern.actions.knowMore') }}
                  <v-icon size="11px">mdi-open-in-new</v-icon></a
                ></span
              ></span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pb-0">
          <img src="@/assets/video-preview-step1.svg" />
          <v-textarea
            class="mt-6"
            no-resize
            readonly
            @focus="$event.target.select()"
            dense
            rows="3"
            v-model="linkEmbed"
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click.stop="handleShowLink(linkEmbed)"
                    v-bind="attrs"
                    v-on="on"
                    @mousedown.stop="focusIcon"
                    size="16"
                    class="mt-3 pandaCopy"
                  >
                    panda-copy
                  </v-icon>
                </template>
                <span>
                  {{
                    $t(
                      `message.pages.videoEditModal.${
                        isCopied ? 'copied' : 'copyToClipboard'
                      }`
                    )
                  }}
                </span>
              </v-tooltip>
            </template>
          </v-textarea>
        </v-card-text>
        <v-divider class="mt-2"></v-divider>
        <v-card-actions
          class="px-8 py-6"
          :class="isMobileBreakpoint ? 'mobile-actions' : ''"
        >
          <v-spacer></v-spacer>
          <base-btn type="tertiary" text class="mr-4 px-4" @click="handleClose">
            {{ $t('message.cancel') }}
          </base-btn>

          <base-btn type="primary" large min-width="185px" @click="copyContent">
            {{ $t('message.embedModal.copy') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import i18n from '@/translations/lang'
// import videosApi from '@/services/videosApi'
import { mapState } from 'vuex'

export default {
  name: 'EmbedModalAgent',
  components: {},
  data: () => ({
    open: null,
    isFetching: false,
    isFocused: false,
    agent: false,
    video: {
      name: '',
    },
    edit: false,
    videoId: '',
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    isStaging() {
      return !!window.location.host.match(/stg.dashboard|localhost/)
    },
    linkEmbed() {
      if (this.assistant.videos) {
        const isStaging = this.isStaging ? '.stg' : ''
        const iframeSrc = `https://player-${this.assistant.pullzone_name}${isStaging}.tv.pandavideo.com.br/embed/assist_chat.html?v=${this.assistant.videos[0]?.video_external_id}&l=${this.assistant.pullzone_name}&embed=true`

        return (
          ` <iframe id="assistChatIframe" src='${iframeSrc}' style="position:fixed;bottom:20px;right:20px;z-index:9999;height:50px;width:350px;border:none" allow="clipboard-write"> </iframe> <script>(()=>{const e=document.getElementById("assistChatIframe");window.addEventListener("message",(t)=>{"toggleOpen"===t.data&&(e.style.height="600px", e.style.width="350px"),"toggleClose"===t.data&&(e.style.height="50px", e.style.width="50px")})})();</scr` +
          'ipt>'.trim()
        )
      }
      return ''
    },

    playerSettingsArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/'
      }
      return 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/'
    },
  },
  props: {
    assistant: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  watch: {
    open(val) {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
      if (val === false) this.$root.$emit('EmbedModalAgentHasClosed')
    },
  },
  mounted() {
    this.$root.$on('openEmbedModalAgent', () => {
      this.open = true
    })

    this.$nextTick(() => {
      const textarea = document.querySelector(
        '.v-input.wrapText.v-textarea.embedInput textarea'
      )
      if (textarea) {
        textarea.onclick = () => {
          textarea.select()
          this.handleShowLink(this.textareaContent)
        }
      }
    })
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    this.$root.$off('embedModalAgent')
    this.$root.$emit('resetIsAnyOtherModal')
    this.$root.$emit('embedModalAgentClosed')
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapActions('video', ['getVideoConfig', 'getVideoProfileId']),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_PLAYER',
      'UPDATE_VIDEO_PROFILE_ID',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    openHelp() {
      window.open(this.playerSettingsArticle, '_blank')
    },
    handleClickOutside() {
      this.isFocused = false
    },
    focusIcon(event) {
      event.preventDefault()
      this.isFocused = true
    },
    handleClose() {
      this.open = null
      this.$root.$emit('renameModalClosed')
    },
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
      this.copyContent()
    },
    copyContent() {
      navigator.clipboard.writeText(this.linkEmbed)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$t('message.embedModal.successCopy'),
        type: 'success',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.renameVideoModalTitle {
  color: varFigma(neutral-20-dark);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 21.6px */
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--v-background-base);
  z-index: 10;
  padding: 16px;
}
</style>
